import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ICreateSaidaGate,
  IGetReceiptSaidaGate,
  IGetSaidasGate,
  IGetSaidasParams,
  IUpdateSaidaGate
} from './saidaGate.model';

@Injectable({
  providedIn: 'root'
})
export class SaidaGateService {
  constructor(private http: HttpClient) {}

  public CreateSaidaGate(
    body: ICreateSaidaGate,
    guid: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      IdempotencyKey: guid
    });

    return this.http.post<any>(
      `${environment.baseURL}GateSaida/CreateGateSaida`,
      body,
      { headers: headers }
    );
  }

  public UpdateSaidaGate(body: IUpdateSaidaGate, id: number): Observable<any> {
    return this.http.put<any>(
      `${environment.baseURL}GateSaida/UpdateGateSaida?id=${id}`,
      body
    );
  }

  public GetSaidas(params?: IGetSaidasParams): Observable<IGetSaidasGate> {
    const url = `${environment.baseURL}GateSaida/GetGateSaidasInfo`;

    let httpParams = new HttpParams();

    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }

    return this.http.get<IGetSaidasGate>(url, { params: httpParams });
  }

  public GetSaidasById(id: number): Observable<any> {
    const url = `${environment.baseURL}GateSaida/GetGateSaidaById`;
    let params: any = {};

    params.id = id;

    return this.http.get<any>(url, { params });
  }

  public GetReceiptGateSaidayId(
    id: number,
    tipoDocumento: number
  ): Observable<any> {
    const url = `${environment.baseURL}GateSaida/GetReceiptGateSaidaById`;
    const params: IGetReceiptSaidaGate = {
      PK_GATE_SAID: 0,
      FL_TIPO_DOCU: 0
    };

    params.PK_GATE_SAID = id;
    params.FL_TIPO_DOCU = tipoDocumento;

    return this.http.get<any>(url, { params } as Object);
  }
}
